import React, { FC } from 'react'
import DefaultGrid from '../../../../../static/steam-img/no-image-grid.svg'

//* utils
import { OPTIONS } from '../../../../constants/dateOptions'
import { LocaleCodes } from '../../../../constants/localization.constants'
import ImgUtil from '../../../../utils/img.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import Button from '../../button'
import Typography from '../../typography'
import VideoPlayer from '../../videoPlayer'

type ImageContainerProps = {
  itemData: any
  assets: any
  companyLogo: string
  companyAltText: string
  videoIcon: string
  categoryIcon: string
  categoryAltText: string
  locale: string
  when: string
  resourceRowData: any
}

type TextContainerProps = {
  resourceRowData: any
  itemData: any
  assets: any
  ctaText: string
  isHomePage: boolean
  pageLink: string
  convertedDate: any
  datePassed: boolean
  includedDateCategory: boolean
  locale: string
}
const UseCaseValues = {
  FULL_WIDTH: 'Full width',
}
export const ImageContainer: FC<ImageContainerProps> = ({
  itemData,
  assets,
  companyLogo,
  companyAltText,
  videoIcon,
  categoryIcon,
  categoryAltText,
  locale,
  when,
  resourceRowData,
}) => (
  <div className="ResourceRow__Image-Container">
    {resourceRowData.useCase === UseCaseValues.FULL_WIDTH ? (
      <div className="ResourceRow__CtaBox">
        <Button
          href={itemData.pageLink}
          icon={true}
          text={``}
          type="primary"
          size="small"
          theme={'light'}
        />
      </div>
    ) : companyLogo ? (
      <img
        className="ResourceRow__Item-Logo"
        src={ImgUtil.getResizedImageUrl(companyLogo, 'width=240')}
        alt={companyAltText}
        width={240}
        height={240}
      />
    ) : videoIcon ? (
      <img
        className="ResourceRow__Item-Icon"
        src={videoIcon}
        alt="Play button"
        width={48}
        height={48}
      />
    ) : categoryIcon ? (
      <img
        className="ResourceRow__Item-Icon"
        src={ImgUtil.getResizedImageUrl(categoryIcon, '')}
        alt={categoryAltText}
        width={48}
        height={48}
      />
    ) : (
      ''
    )}
    <div className="ResourceRow__Pill-Container">
      {itemData.category.title === 'Webinar' && when === 'after' && (
        <Typography type="microAlt" className="ResourceRow__Pill">
          ON DEMAND
        </Typography>
      )}

      {itemData.inEnglish && locale !== LocaleCodes.ENGLISH.code && (
        <Typography type="microAlt" className="ResourceRow__Pill">
          {itemData.inEnglishText}
        </Typography>
      )}
    </div>
    <img
      className="ResourceRow__BackgroundImg"
      src={
        assets.image.url ? ImgUtil.getResizedImageUrl(assets.image.url, 'width=400') : DefaultGrid
      }
      alt={assets.image.altText ? assets.image.altText : 'Dotted Grid'}
      width={384}
      height={384}
    />
  </div>
)

const eyebrowText = (etext: string) => {
  return (
    <Typography type="captionAlt" className="ResourceRow__Item-Category">
      {etext}
    </Typography>
  )
}

export const TextContainer: FC<TextContainerProps> = ({
  resourceRowData,
  itemData,
  assets,
  ctaText,
  isHomePage,
  pageLink,
  convertedDate,
  datePassed,
  includedDateCategory,
  locale,
}) => {
  const videoOverlayData = {
    video: itemData?.tcVideo,
    imageUrl: itemData?.image?.url,
    imgAlt: itemData?.image?.altText,
  }
  const tcVideoStatus = itemData.tcVideo.id || itemData.tcVideo.url || ''
  return (
    <>
      {tcVideoStatus && (
        <div className="TextContainer_Video_Overlay">
          <VideoPlayer
            width={'100%'}
            height="auto"
            videoId={videoOverlayData.video.id}
            videoUrl={videoOverlayData.video.url}
            type={videoOverlayData.video.type}
            img={
              videoOverlayData.imageUrl ? videoOverlayData.imageUrl : videoOverlayData.video.image
            }
            backgroundAltText={videoOverlayData?.video?.altText}
            backgroundImgParams={'width=732'}
            start={videoOverlayData.video.start}
            animationFileUrl={videoOverlayData.video.animationFile}
          />
        </div>
      )}
      <div
        className={
          resourceRowData.noMedia === true
            ? 'ResourceRow__Text-Container noMediaContainer'
            : 'ResourceRow__Text-Container'
        }>
        <div>
          {!isHomePage && (itemData.category.title || convertedDate || itemData.tcEyebrow) && (
            <div className="ResourceRow__Meta-Container">
              {itemData.category.title && eyebrowText(itemData.category.title)}
              {itemData.tcEyebrow && eyebrowText(itemData.tcEyebrow)}

              {itemData.date && !datePassed && includedDateCategory && (
                <Typography type="caption" className="ResourceRow__Item-Date">
                  {new Date(itemData.date).toLocaleDateString(locale, OPTIONS)}
                </Typography>
              )}
            </div>
          )}

          {assets.heading && (
            <Typography className="ResourceRow__Item-Heading" type="header5">
              {formatInlineCode(assets.heading)}
            </Typography>
          )}

          {itemData.body && typeof itemData.body !== 'string' ? (
            <Typography type="body" className="ResourceRow__Item-Body font__inter">
              {renderRichText(itemData.body)}
            </Typography>
          ) : (
            <Typography type="bodyXSWrapper" className="ResourceRow__Item-Body font__inter">
              {itemData.body || ''}
            </Typography>
          )}
        </div>
        {!resourceRowData.hideCtas && ctaText && (
          <Button
            icon={true}
            href={pageLink}
            text={ctaText}
            type="text-link"
            size="small"
            theme={'light'}
          />
        )}
        {resourceRowData.useCase === UseCaseValues.FULL_WIDTH && resourceRowData.noMedia && (
          <div className="ResourceRow__CtaBox noMedia">
            <Button
              href={itemData.pageLink}
              icon={true}
              text={``}
              type="primary"
              size="small"
              theme={'light'}
            />
          </div>
        )}
      </div>
    </>
  )
}
